import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ImageSlot from "./ImageSlot";

export const StatusTag = ({ status }) => (
  <span
    className={`inline-block border px-2 py-1 font-mono text-[10px] uppercase tracking-[0.18em] ${
      status === "EXECUTED CAMPAIGN" ? "border-blue text-blue" : "border-ink text-ink"
    }`}
  >
    {status}
  </span>
);

const WorkCard = ({ study, index }) => (
  <Link
    to={`/work/${study.slug}`}
    data-testid={`work-card-${study.slug}`}
    className="group block"
  >
    <div className="overflow-hidden">
      <div className="transition-transform duration-500 ease-out group-hover:scale-[1.03]">
        <ImageSlot label={study.project} image={study.image} alt={`${study.project} — campaign board`} />
      </div>
    </div>
    <div className="mt-6 flex items-start justify-between gap-4 border-t border-ink pt-4">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">
          {String(index + 1).padStart(2, "0")} — {study.brand}
        </p>
        <h3 className="mt-2 font-display text-2xl font-semibold tracking-tight transition-colors duration-300 group-hover:text-blue md:text-3xl">
          {study.project}
        </h3>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-smoke">
          {study.thought}
        </p>
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <StatusTag status={study.status} />
          {study.tags.map((t) => (
            <span
              key={t}
              className="border border-line px-2 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-smoke"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
      <span
        data-testid={`view-case-${study.slug}`}
        className="mt-1 flex shrink-0 items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-ink transition-colors duration-300 group-hover:text-blue"
      >
        View Case
        <ArrowRight
          size={14}
          className="transition-transform duration-300 group-hover:translate-x-1"
        />
      </span>
    </div>
  </Link>
);

export default WorkCard;
